<div class="space-y-6">
  <div *ngIf="error()" class="rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
    {{ error() }}
  </div>
  <div *ngIf="success()" class="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
    {{ success() }}
  </div>

  <section class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-gray-900">
    <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Consumo actual</h2>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Tus 50 mensajes gratis se reinician por ciclo de suscripción.
    </p>

    <div *ngIf="status() as statusData" class="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <div class="rounded-xl bg-gray-50 p-4 dark:bg-gray-800/60">
        <p class="text-xs text-gray-500">Gratis usados</p>
        <p class="text-xl font-bold text-gray-900 dark:text-white">{{ statusData.freeUsed }} / {{ statusData.freeQuotaLimit }}</p>
      </div>
      <div class="rounded-xl bg-gray-50 p-4 dark:bg-gray-800/60">
        <p class="text-xs text-gray-500">Gratis restantes</p>
        <p class="text-xl font-bold text-gray-900 dark:text-white">{{ statusData.freeRemaining }}</p>
      </div>
      <div class="rounded-xl bg-gray-50 p-4 dark:bg-gray-800/60">
        <p class="text-xs text-gray-500">Saldo paquetes</p>
        <p class="text-xl font-bold text-gray-900 dark:text-white">{{ statusData.packageRemainingCredits }}</p>
      </div>
      <div class="rounded-xl bg-indigo-50 p-4 dark:bg-indigo-900/20">
        <p class="text-xs text-indigo-500">Total disponible</p>
        <p class="text-xl font-bold text-indigo-700 dark:text-indigo-300">{{ statusData.totalRemainingCredits }}</p>
      </div>
    </div>

    <p *ngIf="status() as statusData" class="mt-4 text-xs text-gray-500">
      Ciclo actual: {{ statusData.cycleStartUtc | date:'mediumDate' }} - {{ statusData.cycleEndUtc | date:'mediumDate' }}
    </p>
  </section>

  <section class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-gray-900">
    <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Comprar paquetes de mensajes</h2>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Paquetes disponibles: 100, 200, 500, 1000, 2000, 5000 y personalizado (+5000).
    </p>

    <div class="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" *ngIf="catalog().length">
      <button
        *ngFor="let item of catalog()"
        type="button"
        class="rounded-xl border px-4 py-3 text-left transition"
        [class.border-indigo-500]="selectedCatalogId() === item.messagePackageCatalogId"
        [class.bg-indigo-50]="selectedCatalogId() === item.messagePackageCatalogId"
        [class.border-gray-200]="selectedCatalogId() !== item.messagePackageCatalogId"
        (click)="selectPackage(item)">
        <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ item.name }}</p>
        <p class="text-xs text-gray-500">
          <ng-container *ngIf="item.priceCop; else variablePrice">
            {{ item.priceCop | currency:'COP':'symbol-narrow':'1.0-0' }}
          </ng-container>
          <ng-template #variablePrice>Precio calculado al pagar</ng-template>
        </p>
      </button>
    </div>

    <div class="mt-4" *ngIf="isSelectedPackageCustom()">
      <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Cantidad personalizada (mayor a 5000)
      </label>
      <input
        type="number"
        min="5001"
        step="1"
        (input)="onCustomQuantityInput($event)"
        class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white" />
    </div>

    <div class="mt-5 flex items-center gap-3">
      <button
        type="button"
        (click)="buySelectedPackage()"
        [disabled]="buying() || loading()"
        class="rounded-xl bg-[#6C4DFF] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#5f44e6] disabled:opacity-50 disabled:cursor-not-allowed">
        {{ buying() ? 'Procesando...' : 'Comprar paquete' }}
      </button>
      <button
        type="button"
        (click)="loadData()"
        [disabled]="loading()"
        class="rounded-xl border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 disabled:opacity-50">
        Actualizar saldos
      </button>
    </div>
  </section>
</div>
